import { Event, EventHint, ErrorEvent } from '@sentry/vue'

import { addFederatedInfo } from './federatedApps'
import { addUnhandledRejectionTrace } from './unhandledRejections'
import { conditionalProfiling } from './conditionalProfiling'
import { filterExemptedErrors } from './ignoredExceptions'
import { filterFirebaseError } from './firebase'
import { filterMacOsUnwantedExceptions } from './macOsErrors'
import { filterCustomJsErrors } from './filteringCustomJsError'

// Filter function specifically for error events
export const filterErrorEvents = (event: ErrorEvent, hint: EventHint): ErrorEvent | null => {

  if (filterCustomJsErrors(event)) {
    return null
  }

  /** Unhandled Rejections */
  const unhandledRejectionEvent = addUnhandledRejectionTrace(event, hint)
  if (unhandledRejectionEvent) {
    return addFederatedInfo(unhandledRejectionEvent) as ErrorEvent
  }

  /** Custom Filters  */
  const isFilteredOut = [
    filterExemptedErrors(event, hint),
   // filterFirebaseError(event, hint),
    filterMacOsUnwantedExceptions(hint),
  ].some(Boolean)

  if (isFilteredOut) {
    return null
  }

  return addFederatedInfo(event) as ErrorEvent
}

// General filter function for all event types (kept for backward compatibility)
export const filterEvents = (event: Event, hint: EventHint): Event | null => {
  if (event.type === 'profile') {
    return conditionalProfiling(event)
  }

  // For error events, use the specific error filter
  if ('exception' in event || 'message' in event) {
    return filterErrorEvents(event as ErrorEvent, hint)
  }

  // For other event types, just add federated info
  return addFederatedInfo(event)
}
